<template>
  <div class="py-3">
    <a-form :form="form" @submit="handleSubmit">
      <div class="pb-1">
        <a-form-item label="Application Id" class="mb-2">
          <a-input
            size="large"
            placeholder="Application id"
            v-decorator="['application_id', { rules: [{ required: true, message: 'Please input your application id!' }]}]"
          />
        </a-form-item>
        <a-form-item label="Password" class="mb-2">
          <a-input
            size="large"
            placeholder="Password"
            type="password"
            v-decorator="['password', { rules: [{ required: true, message: 'Please input your Password!' }]}]"
          />
        </a-form-item>
      </div>
      <hr>
      <a-button
        type="primary"
        htmlType="submit"
        size="large"
        class="text-center btn btn-primary w-50 font-weight-bold font-size-18 mt-2"
      >Log in</a-button>
    </a-form>
  </div>
</template>

<script>
import store from '@/store'
import { mapState } from 'vuex'

export default {
  name: 'ApplicationLogin',
  props: ['schoolId', 'formId'],
  mounted: function() {
    this.loading = true
  },
  computed: {
    ...mapState(['applicant']),
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      school: {},
      loading: true,
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$nprogress.start()
          this.$http.post(`/api/application-form/login/${this.formId}`, {
            application_id: values.application_id,
            password: values.password,
            school_id: this.schoolId,
          })
            .then(async ({ data }) => {
              this.$nprogress.done()
              if (data.data) {
                localStorage.setItem('applicant_id', data.data.id)
                localStorage.setItem('app_form_token', data.data.token)
                await store.commit('UPDATE_APPLICANT_ID', { id: data.data.id })
                await store.commit('UPDATE_APP_FORM_TOKEN', { token: data.data.token })
                this.$notification['success']({
                  message: 'Logged In',
                  description: 'You have successfully logged in!',
                })
              } else if (data.type === 'error') {
                this.$neoNotify.error(data)
              }
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        }
      })
    },
  },
}
</script>

<style>

</style>
